import { type ReactNode } from 'react'
import { HelpIcon } from '@/shared/components/HelpIcon'
import type { ModalName } from '@/lib/modalTelemetry'
import { FindingsChart, type FindingsDrilldown } from '@/features/dashboard/cards/FindingsChart'

/**
 * One half of the "Open findings" pair: a severity ring scoped to the current artifacts
 * (latest published module versions on the left card, each workspace's current state on
 * the right) - the same scope as the risk cards, so the numbers always agree.
 */
export function OpenFindingsCard({
  title,
  helpTrack,
  findings,
  drilldown,
  help,
}: {
  title: string
  helpTrack: ModalName
  findings: Array<{ severity: string; count: number }>
  drilldown?: FindingsDrilldown[]
  help: ReactNode
}) {
  return (
    <div className="card fu">
      <div className="card-header">
        <div>
          <div className="kicker">Security</div>
          <h3 style={{ fontSize: '0.95rem' }}>{title}</h3>
        </div>
        <HelpIcon track={helpTrack} title={title} kicker="// what this implies">
          {help}
        </HelpIcon>
      </div>
      <div style={{ padding: '16px 18px' }}>
        <FindingsChart findings={findings} drilldown={drilldown} />
      </div>
    </div>
  )
}
